export const QA_NAME_REQUEST_PROFILE_TAB_RATING_ADD_NEW =
  'requestProfileTabRatingAddNew'

export const QA_NAME_REQUEST_PROFILE_TAB_RATING_COMMENTS =
  'requestProfileTabRatingComments'

export const RATING_CARD_ACTION_EDIT = 'edit'
